/*
 * closeEproDevicePopupController
 * */
/* eslint-disable no-underscore-dangle */
class closeEproDevicePopupController {
	constructor($timeout, iSpiroService, loadingIndicatorService,
		signatureService, appI18n, appConfig, $stateParams, $q,
		ertBasePopupService, notificationService, userService, eproService) {
		'ngInject';
		this.$timeout = $timeout;
		this.$stateParams = $stateParams;
		this.iSpiroService = iSpiroService;
		this.loadingIndicatorService = loadingIndicatorService;
		this.signatureService = signatureService;
		this.ertBasePopupService = ertBasePopupService;
		this.notificationService = notificationService;
		this.userService = userService;
		this.eproService = eproService;
		this.appI18n = appI18n;
		this.appConfig = appConfig;
		this.$q = $q;
		this.onlineHelpId = 'MSP3.ClinicalData.ISpiro.closeEproDevice';

		this.isLoading = false;
		this.$API = null;
		this.iSpiroForm = null;
		this.state = null;
		this.hasDOB = false;
		this.dobIsInFutureMsg = null;
		this.isFormValid = false;
		this.formData = null;
		this.subjectDemographics = null;
		this.additionalAttributes = null;
		this.studyContext = null;
		this.siteId = null;
		this.technicalSubjectId = null;
		this.subjectId = null;
		this.isEdit = false;
		this.heading = 'Dispense Device';
		this.cancelBtn = null;
		this.closeHeadingId = 'clinicaldata.subject.epro.closeDeviceHeading';
		this.displaySiteNames = [];
		this.displaySubjectKeys = [];
		this.provisionedAppId = null;
		this.deviceActionWidgetEl = null;
		this.protocolSetupLabels = [];
		this.source = null;
		this.externalSiteId = null;
		this.closeInfoText = appI18n.translateImmediate('clinicaldata.subject.epro.remoteCloseText');
		this.coughCloseInfoText = appI18n.translateImmediate('clinicaldata.subject.cough.remoteCloseText');
		this.homeBpCloseInfoText = appI18n.translateImmediate('clinicaldata.subject.homeBp.remoteCloseText');


		this.errors = {
			genericError: false
		};

		// ACTION BUTTONS
		this.submitBtn = {
			action: () => {
				this.close();
				this.clearActions();
			},
			cssClass: '-es-primary',
			displayName: 'app.buttons.submit',
			isDisabled: false,
			type: 'submit'
		};
		this.cancelBtn = {
			action: () => {
				this.cancelAction();
			},
			displayName: 'app.buttons.cancel',
			isDisabled: false
		};

		this.isEditBlocked = false;
	}

	$onInit() {

		this.configure();
		this.$API = this.setApi();
		this.componentReady && this.componentReady({ $API: this.$API });

		if (this.$stateParams.signKey) {
			const state = this.signatureService.getState(this.$stateParams.signKey);

			if (state) {
				if (state.sigType === this.getSignatureType()) {
					this.state = state;
				}
			}
		}
	}
	clearActions() {
		this.actions = [];
	}
	closeDevice(data, siteId) {
		const provisonedAppData = data.find(d => d.context.appId === this.provisionedAppId);
		const qrCodePayload = {
			context: {
			  subjectContext: provisonedAppData.context.subjectContext,
			  participantId: '',
			  appId: provisonedAppData.context.appId,
			},
			type: 'AppChangeProvisioningStatus',
			data: {
				provisioningStatus: 'DEPROVISIONED'
			}
		  };
		  this.eproService.closeDevice(provisonedAppData.context.appId, qrCodePayload, siteId).then((response) => {
			if(this.isHomeBpStudy)
			{
				this.deviceActionWidgetEl[0].qrCode = response.data.data.qrCodeContents;
				this.deviceActionWidgetEl[0].QRCodeValue = true;
			}
			else
			{
				this.eproService.getDeviceState(provisonedAppData.context.appId).then((state) => {
					this.pollForStatus();
				});
			}
			this.loadingIndicatorService.hide();
		  }).catch(() => {
			this.loadingIndicatorService.hide();
		  });
	}

	pollForStatus() {
		const pollInterval = 5000; // Poll every 5 seconds
		const timeoutDuration = this.appConfig.constants.closeDeviceRetryTime;
		const startTime = Date.now();
	
		const poll = () => {
			this.eproService.getDeviceState(this.provisionedAppId).then((response) => {
				if (response.data.data.provisioningStatus === 'DEPROVISIONED') {
					this.open = false;
					this.notificationService.showSuccess(
						this.appI18n.translateImmediate('clinicaldata.subject.epro.closeDeviceSuccess')
					);
				} else if (Date.now() - startTime < timeoutDuration) {
					// Continue polling if timeout has not been reached
					this.$timeout(poll, pollInterval);
				} else {
					this.open = false;
					this.notificationService.showWarning(
						this.appI18n.translateImmediate('clinicaldata.subject.epro.closeDeviceTimeout')
					);
				}
			}).catch((error) => {
				if (Date.now() - startTime < timeoutDuration) {
					this.$timeout(poll, pollInterval);
				} else {
					this.loadingIndicatorService.hide();
				}
			});
		};
		poll();
	}
	showSuccessMessage() {
		const placeholderEl = angular.element(document).find('#device-action-dispense-placeholder');
		placeholderEl.empty().append('<h4>Subject data is updated.</h4>');
		this.loadingIndicatorService.hide();
	}

	close() {

		if(this.isHomeBpStudy) {
			this.deviceActionWidgetEl[0].showInfoText = false;
			this.loadingIndicatorService.show();
		}
		this.deviceActionWidgetEl[0].showClosingSpinner = !this.isHomeBpStudy;
		this.deviceActionWidgetEl[0].showInfoBox = false;
		
		if (this.source === 'RESP Biosensor') {
			const closePayload = {
				studyId: this.studyContext.studyId,
				siteId: this.externalSiteId,
				subjectId: this.technicalSubjectId
			};

			this.eproService.closeStradosCough(closePayload).then((response) => {
				this.open = false;
				this.notificationService.showSuccess(
					this.appI18n.translateImmediate('clinicaldata.subject.epro.closeDeviceSuccess')
				);
				this.loadingIndicatorService.hide();
			}).catch((error) => {
				this.open = false;
				this.notificationService.showError(
					this.appI18n.translateImmediate('clinicaldata.subject.epro.closeDeviceError')
				);
				this.loadingIndicatorService.hide();
			});
		} else {
		this.eproService.closeDeviceInit(this.technicalSubjectId).then((response) => {
			this.closeDevice(response.data, this.siteId);
		}).catch(() => {
			this.notificationService.showError(
				this.appI18n.translateImmediate('clinicaldata.subject.epro.closeDeviceError')
			);
		});
	}
	}
	

	configure() {
		this.popupHeading = 'clinicaldata.subject.i-spiro.close-dispense.dispenseTitle';
	}


	setApi() {
		const $API = {
			open: (isRemoteAction, countryId, siteId, technicalSubjectId, displaySiteName, subjectKey, subjectId, isLost, source, isHomeBpStudy) => {
				
				this.loadingIndicatorService.show();
				this.heading = this.closeHeadingId;
				this.siteId = siteId;
				this.technicalSubjectId = technicalSubjectId;

				this.actions = [this.submitBtn, this.cancelBtn];
				this.open = true;
				this.source = source;
				this.isHomeBpStudy = isHomeBpStudy;
				if(this.source === 'RESP Biosensor')
				{
					const additionalAttributesPromise = this.eproService.getAdditionalAttributes(siteId, technicalSubjectId);
					const protocolSetupLabelsPromise = this.eproService.getProtocolSetupLabels();

					this.$q.all([additionalAttributesPromise, protocolSetupLabelsPromise])
						.then((responses) => {
							const additionalAttributesResponse = responses[0];
					const rawLabels = responses[1].data;
					const protocolSetupLabels = [
						rawLabels.find(l => l.fieldKey === 'IT_9')?.dfcLabel,
						rawLabels.find(l => l.fieldKey === 'PAT_SUBJECTID')?.dfcLabel
					].filter(Boolean);
					this.protocolSetupLabels = protocolSetupLabels;
							this.studyContext = additionalAttributesResponse.data;
							this.externalSiteId = additionalAttributesResponse.data.siteId;

							this.$timeout(() => {
								const placeholderEl = angular.element(document).find('#close-placeholder');
								this.deviceActionWidgetEl = angular.element('<device-action-close  />');
								this.deviceActionWidgetEl[0].addEventListener('formDataChange', (event) => {
									const formData = event.detail;
									this.formData = formData;
								});
								this.deviceActionWidgetEl[0].siteIds = [displaySiteName];
								this.deviceActionWidgetEl[0].subjectIds = [subjectKey];
								this.deviceActionWidgetEl[0].infoText = this.coughCloseInfoText;
								this.deviceActionWidgetEl[0].showInfoBox = false;
								this.deviceActionWidgetEl[0].source = source;
								this.displaySiteNames = [displaySiteName];
								this.displaySubjectKeys = [subjectKey];
								this.deviceActionWidgetEl[0].vocabulary = this.protocolSetupLabels;
								placeholderEl.empty().append(this.deviceActionWidgetEl);
								this.loadingIndicatorService.hide();
							}, 200);
						})
						.catch(() => {
							this.loadingIndicatorService.hide();
							this.notificationService.error('Error loading data');
						});
				}
				else
				{
				
				const protocolSetupLabelsPromise = this.eproService.getProtocolSetupLabels();
				const provisionedAppIdsPromise = this.eproService.getProvisionedAppIds(siteId, technicalSubjectId);

				this.$q.all([provisionedAppIdsPromise, protocolSetupLabelsPromise]).then((responses) => {
					const response = responses[0];
				const rawLabels = responses[1].data;
				const protocolSetupLabels = [
					rawLabels.find(l => l.fieldKey === 'IT_9')?.dfcLabel,
					rawLabels.find(l => l.fieldKey === 'PAT_SUBJECTID')?.dfcLabel
				].filter(Boolean);
				this.protocolSetupLabels = protocolSetupLabels;
					if (response.data.length === 1) {
						this.provisionedAppId = response.data[0];
						this.$timeout(() => {
							const placeholderEl = angular.element(document).find('#close-placeholder');
							this.deviceActionWidgetEl = angular.element('<device-action-close  />');
		
							
							this.deviceActionWidgetEl[0].addEventListener('formDataChange', (event) => {
								const formData = event.detail;
								this.formData = formData;
							});
						
							this.deviceActionWidgetEl[0].addEventListener('formValidationChange', (event) => {
								const isFormValid = event.detail;
								this.isFormValid = isFormValid;
							});
		
							this.deviceActionWidgetEl[0].siteIds = [displaySiteName];
							this.deviceActionWidgetEl[0].subjectIds = [subjectKey];
							this.deviceActionWidgetEl[0].infoText = isHomeBpStudy ? this.homeBpCloseInfoText : this.closeInfoText;
							this.deviceActionWidgetEl[0].showInfoBox = isHomeBpStudy ? false : true;
							this.displaySiteNames = [displaySiteName];
							this.displaySubjectKeys = [subjectKey];
							this.deviceActionWidgetEl[0].vocabulary = this.protocolSetupLabels;
							placeholderEl.empty().append(this.deviceActionWidgetEl);
							this.loadingIndicatorService.hide();
						}, 200);
					} else {
						this.notificationService.showError(
							this.appI18n.translateImmediate('clinicaldata.subject.epro.closeDeviceError')
						);
						this.loadingIndicatorService.hide();
					}
				}).catch(() => {
					this.loadingIndicatorService.hide();
					this.notificationService.error('Error loading data');
				});
			}
				
			},
			close: () => {
				this.open = false;
			}
		};
		return $API;
	}

	cancelAction() {
		this.$API.close();
	}

	getSignatureType() {
		return this.appConfig.sigType.noSignature;
	}

}
/* eslint-enable no-underscore-dangle */
export default closeEproDevicePopupController;
